import { Text, Banner, GreyGrey90, Flex } from '@sequencehq/core-components'
import { ConfigureXeroMappingsLink } from 'Products/components/ConfigureXeroMappingsLink'

type NoXeroMappingsBannerProps = {
  'data-testid'?: string
}

export const NoXeroMappingsBanner = ({
  'data-testid': dataTestId
}: NoXeroMappingsBannerProps) => (
  <Banner
    variant="neutral"
    data-testid={dataTestId ?? 'xeroMappings.noMappingsBanner'}
  >
    <Flex flexDirection="column" width="100%" gap={1}>
      <Text color={GreyGrey90} width="100%">
        No Xero ledger account mappings configured. Set up mappings before
        assigning them to products.
      </Text>
      <ConfigureXeroMappingsLink />
    </Flex>
  </Banner>
)
